import {
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack,
} from '@mui/material';
import ComponentMemoizer from 'Global/Components/ComponentMemoizer/ComponentMemoizer';
import React from 'react';
import { v4 as uuidV4 } from 'uuid';
import useSetRadioFormValue from './Logic/useSetRadioFormValue';
import EditElementTypeMatcher from 'Global/Components/EditableComponents/EditableGroupedView/EditElementTypeMatcher';
import { GroupByRadioType } from 'Global/Components/CommonComponents/GroupedView/Functions/GroupByRadioType';
import { ArabicToPersian } from 'utils/ConvertToPersianTextFromArabic';
const EditableElectronicFormRadioGenerator = ({
  element,
  setValue,
  onChange,
  control,
  errors,
  initialValue,
}) => {
  const { handleChange, value, children } =
    useSetRadioFormValue(element, setValue, initialValue);
  return (
    <React.Fragment>
      <Stack gap="1em">
        <RadioGroup
          aria-labelledby="radio-button-group"
          name={`name${element.PannelNo}`}
          sx={{
            flexDirection: 'column-reverse',
            '::before':
              children?.length > 0
                ? {
                    content: '""',
                    display: 'block',
                    alignSelf: 'right',
                    width: '.1em',
                    height: '2em',
                    backgroundColor: 'black',
                  }
                : {},
          }}
          onChange={handleChange}
          value={value}
        >
          <ComponentMemoizer
            element={element?.map((radio) => (
              <FormControlLabel
                value={radio?.name}
                control={<Radio />}
                label={
                  ArabicToPersian(
                    radio?.element?.LablelNameForWeb
                  ) || ArabicToPersian(radio?.name)
                }
                key={uuidV4()}
              />
            ))}
            dependecies={JSON.stringify(element)}
          />
        </RadioGroup>
        <Stack
          gap=".5em"
          border={
            children?.length > 0
              ? '1px solid gainsboro'
              : ''
          }
          padding={
            children?.length > 0 ? '.5em 1em .5em 1em' : ''
          }
        >
          {children?.length > 0 ? (
            GroupByRadioType(children)?.map((child) => (
              <EditElementTypeMatcher
                field={child}
                onChange={onChange}
                control={control}
                errors={errors}
                setValue={setValue}
                key={uuidV4()}
              />
            ))
          ) : (
            <></>
          )}
        </Stack>
      </Stack>
    </React.Fragment>
  );
};

export default EditableElectronicFormRadioGenerator;

{
  /* {element?.map((group, index) => (
        <RadioGroup
          aria-labelledby="radio-button-group"
          name={`name${index}`}
          key={index}
        >
          {group?.map((radio) => (
            <FormControlLabel
              value={radio?.name}
              control={<Radio />}
              label={radio?.name}
              key={uuidV4()}
            />
          ))}
        </RadioGroup>
      ))} */
}
